import type { Translate } from "next-translate";

export type PracticePuzzle = {
  id: string;
  fen: string;
  moves: string;
  rating?: number;
  source?: string;
};

export const puzzleCategories = [
  {
    slug: "checkmate",
    theme: "mate",
  },
  {
    slug: "mate-in-one",
    theme: "mateIn1",
  },
  {
    slug: "mate-in-two",
    theme: "mateIn2",
  },
  {
    slug: "mate-in-three",
    theme: "mateIn3",
  },
  {
    slug: "easy",
    theme: "easy",
  },
  {
    slug: "fork",
    theme: "fork",
  },
  {
    slug: "pin",
    theme: "pin",
  },
  {
    slug: "back-rank-mate",
    theme: "backRankMate",
  },
];

export function getPuzzleCategory(slug: string) {
  return puzzleCategories.find((category) => category.slug === slug);
}

export function localizePuzzleCategory(
  category: (typeof puzzleCategories)[number],
  t: Translate,
) {
  const key = `themes.categories.${category.slug}`;
  return {
    ...category,
    title: t(`${key}.title`),
    short: t(`${key}.short`),
    description: t(`${key}.description`),
    tip: t(`${key}.tip`),
  };
}
